export default __webpack_public_path__ + "static/SRUS P250 - Especification Del Producto y Datos Técnicos-9e3d3a956a27f8b49d9a20178c459ee9.pdf";